import Moment from 'moment';
import {extendMoment} from 'moment-range';

const moment = extendMoment(Moment);

// Regroups various utility methods around seasons
class SeasonsUtil {

  /**
   * Returns the default season to use across all seasons available based on the following criteria:
   *   > The active season that will end the closest from the provided date
   *   > if no active seasons, the latest one that finished closest to the provided date
   *   > if no active or past seasons, the next one that will finish the closest to the provided date
   *  @param {Seasons} seasons object holding individual seasons as properties
   *  @param {Date} lookupDate Date to use when finding the default season. 
   *  @returns {String} the resolved season ID 
   */
  static getDefaultSeason(seasons, dateToUse) {

    const providedMoment = moment(dateToUse);

    //The seasons object is a container with each properties set as a distinct season. We want to manipulate the seasons
    //directly so extract them into an array we can work with.
    let seasonsArray = Object.values(seasons);

    if (seasonsArray.length > 0) {

      // sort the seasons by their finish date
      seasonsArray.sort(function(left, right) {
        return moment.utc(left.finish).diff(moment.utc(right.finish))
      });

      //Reduce the sorted seasons array to find the season that fits the function criteria
      let defaultSeason = seasonsArray.reduce((seasonAcc, currentSeason) => {

        currentSeason.isActive = false; //Create a flag to track the accumulated season active status 

        //determine the range of the season being evaluated
        let start = moment(currentSeason.start)
        let end = moment(currentSeason.finish)
        let seasonRange = moment().range(start, end)

        if (seasonRange.contains(providedMoment)) {
          //The season we are evaluating is active. This becomes the default since we are sorted by finish date which would take care
          //of returning the active season that finishes the closest to today.
          currentSeason.isActive = true;

          if (seasonAcc.isActive === true && moment(seasonAcc.finish).diff(providedMoment) < end.diff(providedMoment)) {
            //We have more than one active season and our previous active season finish date is closer to the current date so keep it.
            return seasonAcc;
          } else {
            //Our current season finish date is closer to the date so use this one
            return currentSeason;
          }
        } else if (end.isSameOrBefore(providedMoment) && seasonAcc.isActive !== true) {
          //Not an active season but finished before today so return it if the accumulator season is inactive or is null
          return currentSeason;
        } else if (seasonAcc == null) {
          //We are now handling the case of future seasons with no previous or active seasons found. The current season we are evaluating will be
          //the default season...
          return currentSeason;
        } else {
          //We already found our proper default season so just return it 
          return seasonAcc;
        }
      }, {});

      return defaultSeason.seasonId;
    }
  }
}

export default SeasonsUtil;


// WEBPACK FOOTER //
// ./src/utils/SeasonsUtil.js